<div class="flex flex-col">

  <div class="flex flex-col md:gap-4 md:flex-row md:items-center">
    <span class="text-lg font-semibold">Changes to Acknowledge</span>

    <div class="flex flex-row pt-4 portal-field-grid">
      <mat-form-field>
        <input matInput (keyup)="filterTasks($event)" placeholder="Filter" />
      </mat-form-field>
    </div>

    <div class="flex flex-col md:flex-row gap-4 items-center ml-auto portal-actions">
      <mat-checkbox [(ngModel)]="includeAll" labelPosition="before">
        <span>Include Completed</span>
      </mat-checkbox>
      <button type="button" mat-raised-button color="primary" (click)="entityId === 0? getAllTasks() : getTasks()">Refresh</button>
    </div>
  </div>

  <mat-table [dataSource]="taskSource" matSort #taskSort="matSort" aria-describedby="tasks" class="mat-elevation-z8 portal-responsive-table">
    <ng-container matColumnDef="entityGuid" *ngIf="entityId === 0">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">License Id</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let task">
        <span class="mobile-label">Id</span>
        {{ task.entityGuid }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="entityName" *ngIf="entityId === 0">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Name</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let task">
        <span class="mobile-label">Name</span>
        {{ task.entityName }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="taskText">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Change</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let task">
        <span class="mobile-label">Change</span>
        {{ task.taskText }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="acknowledge">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Acknowledge</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let task">
        <span class="mobile-label">Acknowledge</span>
        <button type="button" mat-button color="primary" (click)="acknowledgeTask(task)">Acknowledge</button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="completed">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Complete</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let task">
        <span class="mobile-label">Complete</span>
        {{ task.completed? 'Yes' : 'No' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="dateCompleted">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Date Completed</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let task">
        <span class="mobile-label">Date Completed</span>
        {{ task.dateCompleted | date: 'short' }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="taskColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: taskColumns" class=""
             [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[20, 50, 100]" #taskPaginator="matPaginator">
  </mat-paginator>

</div>
